if (!customElements.get('piecework-gift-box-add')) {
  customElements.define(
    'piecework-gift-box-add',
    class PieceworkGiftBoxAdd extends HTMLElement {
      constructor() {
        super();
        this.cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cart = document.querySelector('cart-drawer-items');

        this.price = this.querySelector('#cart-gift-price');
        this.text = this.querySelector('#cart-gift-text');
        this.giftBoxes = null;
        this.addButton = this.querySelector('#cart-add-wrapping');
      }
      async setQtyAndPrice() {
        this.giftBoxes = await getGiftBoxes();

        const totalPrice = this.giftBoxes.items.reduce((sum, item) => sum + item.price, 0);

        const textContent = this.text.innerHTML;

        this.price.textContent = `$${totalPrice}`;
        this.text.innerHTML = textContent.replace(
          '${msg}',
          `${this.giftBoxes.items.length} gift box${this.giftBoxes.items.length > 1 ? 'es' : ''}.`
        );
      }
      async addGiftBoxes() {
        this.cart.enableLoading(null);
        await removeGiftBoxes();
        const body = JSON.stringify({
          items: this.giftBoxes.items,
        });

        fetch(`${routes.cart_add_url}`, {
          ...fetchConfig(),
          ...{ body },
        })
          .then((response) => response.json())
          .then(() => {
            const updateBody = JSON.stringify({
              attributes: {
                'Gift wrap': 'Yes',
              },
              sections: this.cart.getSectionsToRender().map((section) => section.section),
              sections_url: window.location.pathname,
            });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body: updateBody },
            })
              .then((response) => response.json())
              .then((updateState) => {
                this.cart.getSectionsToRender().forEach((section) => {
                  const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) ||
                    document.getElementById(section.id);
                  elementToReplace.innerHTML = this.cartDrawer.getSectionInnerHTML(
                    updateState.sections[section.section],
                    section.selector
                  );
                });
              })
              .finally(() => {
                this.cart.disableLoading(null);
              });
          })
          .finally(() => {});
      }
      connectedCallback() {
        this.setQtyAndPrice();
        this.addButton.addEventListener('click', () => {
          this.addGiftBoxes();
        });
      }
    }
  );
}
